// src/pages/Email.js

import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosInstance';
import '../styles/Emails.css';

function Emails() {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [currentTemplate, setCurrentTemplate] = useState(null);
    const [formValues, setFormValues] = useState({ name: '', subject: '', body: '' });

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                console.log('Fetching email templates...');
                const response = await axiosInstance.get('/api/email-templates');
                console.log('Email templates response:', response.data);
                setTemplates(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching templates:', error.response || error.message);
                setError('Failed to load email templates.');
                setLoading(false);
            }
        };

        fetchTemplates();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleSaveTemplate = async () => {
        try {
            if (currentTemplate) {
                await axiosInstance.put(`/api/email-templates/${currentTemplate._id}`, {
                    name: formValues.name,
                    subject: formValues.subject,
                    body: formValues.body,
                    placeholders: [],
                });
                setTemplates((prev) =>
                    prev.map((template) =>
                        template._id === currentTemplate._id ? { ...template, ...formValues } : template
                    )
                );
            } else {
                const response = await axiosInstance.post('/api/email-templates', {
                    name: formValues.name,
                    subject: formValues.subject,
                    body: formValues.body,
                    placeholders: [],
                });
                setTemplates((prev) => [...prev, response.data.template]);
            }

            closeModal();
        } catch (error) {
            console.error('Error saving template:', error);
            setError('Failed to save the template.');
        }
    };

    const handleDeleteTemplate = async (id) => {
        try {
            await axiosInstance.delete(`/api/email-templates/${id}`);
            setTemplates((prev) => prev.filter((template) => template._id !== id));
        } catch (error) {
            console.error('Error deleting template:', error);
            setError('Failed to delete the template.');
        }
    };

    const openModal = (template = null) => {
        setCurrentTemplate(template);
        setFormValues(template || { name: '', subject: '', body: '' });
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setCurrentTemplate(null);
        setFormValues({ name: '', subject: '', body: '' });
    };

    if (loading) return <p>Loading templates...</p>;
    if (error) return <p className="error-message">{error}</p>;

    return (
        <div className="emails-page">
            <h1>Email Templates</h1>
            <button onClick={() => openModal()} className="add-template-btn">
                Add Template
            </button>

            <table className="templates-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Subject</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {templates.map((template) => (
                        <tr key={template._id}>
                            <td>{template.name}</td>
                            <td>{template.subject}</td>
                            <td>
                                <button onClick={() => openModal(template)}>Edit</button>
                                <button onClick={() => handleDeleteTemplate(template._id)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {showModal && (
                <div className="modal">
                    <div className="modal-content">
                        <h2>{currentTemplate ? 'Edit Template' : 'New Template'}</h2>
                        <label>Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formValues.name}
                            onChange={handleInputChange}
                        />
                        <label>Subject</label>
                        <input
                            type="text"
                            name="subject"
                            value={formValues.subject}
                            onChange={handleInputChange}
                        />
                        <label>Body</label>
                        <textarea
                            name="body"
                            value={formValues.body}
                            onChange={handleInputChange}
                        ></textarea>
                        <button onClick={handleSaveTemplate}>Save</button>
                        <button onClick={closeModal}>Cancel</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Emails;